module.exports = __webpack_public_path__ + "img/level_three_hover.e8ab4d4d.png";